export const adminMenuSelectionSwitch = type =>
  ({
    client_picks: 'Client select their own dishes',
    culinistas_picks: 'Culinistas select weekly dishes',
    custom_weekly_selection: 'This is a custom weekly client'
  }[type] || '');

export const clientMenuSelectionSwitch = type =>
  ({
    client_picks: 'I select my own dishes',
    culinistas_picks: 'I want the Culinistas to select my weekly dishes'
  }[type] || '');



// WEBPACK FOOTER //
// ./src/helpers/switches.js